import React, { Component } from 'react'
import GlossaryCard from './GlossaryCard'

import '../App.css'

class ToolFooter extends Component {
    render() {
        return <GlossaryCard glossary={ this.props.glossary } />
    }
}

export default ToolFooter
